
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/pages/my-favourites/partials/no-items/styles.css.ts.vanilla.css\",\"source\":\"LmF1Y200ZTAgewogIGZvbnQtc2l6ZTogMjBweDsKICBsaW5lLWhlaWdodDogMS4yNTsKICBtYXJnaW4tdG9wOiAxMnB4OwogIGZvbnQtd2VpZ2h0OiB2YXIoLS1fMTh3NzZidzN3KTsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5hdWNtNGUwIHsKICAgIGZvbnQtc2l6ZTogMzZweDsKICAgIGxpbmUtaGVpZ2h0OiAxLjY2NjY3OwogICAgbWFyZ2luLXRvcDogMTZweDsKICB9Cn0=\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/pages/my-favourites/partials/no-items/styles.css.ts.vanilla.css\",\"source\":\"LmF1Y200ZTAgewogIGZvbnQtc2l6ZTogMjBweDsKICBsaW5lLWhlaWdodDogMS4yNTsKICBtYXJnaW4tdG9wOiAxMnB4OwogIGZvbnQtd2VpZ2h0OiB2YXIoLS1fMTh3NzZidzN3KTsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5hdWNtNGUwIHsKICAgIGZvbnQtc2l6ZTogMzZweDsKICAgIGxpbmUtaGVpZ2h0OiAxLjY2NjY3OwogICAgbWFyZ2luLXRvcDogMTZweDsKICB9Cn0=\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
